import { useForm, ValidationError } from '@formspree/react';

function CohablistDeletion() {
  const [state, handleSubmit] = useForm('xojbpeva');

  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4 }}>Cohablist — Account Deletion Request</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Last updated: May 2026</p>

      <p>
        To delete your Cohablist account and all associated data, fill in the form below.
        We will process your request within 30 days.
      </p>

      <h2>What will be deleted</h2>
      <ul>
        <li>Your account (email address and sign-in credentials)</li>
        <li>Your display name</li>
        <li>Your membership in any household groups</li>
      </ul>
      <p style={{ color: '#555', fontSize: '0.95rem' }}>
        List items, chores, and events you created within a shared group will remain visible to other group members.
        If you are the last member of a group, all group data will be deleted.
      </p>

      {state.succeeded ? (
        <p style={{ color: '#2a7a2a', background: '#f0faf0', padding: '16px 20px', borderRadius: 8, marginTop: 32 }}>
          ✓ Request received. We'll process your deletion within 30 days.
        </p>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 32 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label htmlFor="email" style={{ fontWeight: 500 }}>Email address used to sign in *</label>
            <input
              id="email"
              type="email"
              name="email"
              required
              placeholder="your@email.com"
              style={{ padding: '10px 14px', borderRadius: 6, border: '1px solid #ccc', fontSize: '1rem', fontFamily: 'inherit' }}
            />
            <ValidationError field="email" prefix="Email" errors={state.errors} style={{ color: '#c0392b', fontSize: '0.9rem' }} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label htmlFor="message" style={{ fontWeight: 500 }}>Additional message (optional)</label>
            <textarea
              id="message"
              name="message"
              rows={3}
              placeholder="Anything you'd like us to know"
              style={{ padding: '10px 14px', borderRadius: 6, border: '1px solid #ccc', fontSize: '1rem', fontFamily: 'inherit', resize: 'vertical' }}
            />
            <ValidationError field="message" prefix="Message" errors={state.errors} style={{ color: '#c0392b', fontSize: '0.9rem' }} />
          </div>

          <ValidationError errors={state.errors} style={{ color: '#c0392b', fontSize: '0.9rem' }} />

          <button
            type="submit"
            disabled={state.submitting}
            style={{ alignSelf: 'flex-start', padding: '10px 24px', borderRadius: 6, border: 'none', background: '#222', color: '#fff', fontSize: '1rem', cursor: 'pointer', opacity: state.submitting ? 0.6 : 1 }}
          >
            {state.submitting ? 'Submitting…' : 'Submit request'}
          </button>
        </form>
      )}

      <p style={{ color: '#888', fontSize: '0.85rem', marginTop: 40 }}>
        Note: deleting your account removes you from any shared groups. Other members and their data are not affected.
      </p>
    </div>
  );
}

export default CohablistDeletion;
